module.exports = __webpack_public_path__ + "images/6c9ea6c18f1d4bb7d919cf8017ed3366-IMG_9390.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slides/living2/IMG_9390.jpg
// module id = ./src/assets/images/slides/living2/IMG_9390.jpg
// module chunks = 0